import React, { useState} from 'react'
// import "./Match_Odds.css";
import Book_mark from "./Book_mark";
import Bet_model from "./betmodel1/Bet_model";

import Fancy_bet from "./Fancy_bet";
import Toss_Winner from "./Toss_Winner";

const data =[
  {
    team: "Kathmandu Gorkhas",
    b1: "1.01",
    b2: "1.08",
    b3: "1.09",
    l1: "960",
    c1: "1.01",
    c2: "1.08",
    c3: "1.09",
    l2: "960",
  },
  {
    team: "Lumbini Lions",
    b1: "0",
    b2: "1.01",
    b3: "1.08",
    l1: "960",
    c1: "1.0",
    c2: "1.08",
    c3: "1.09",
    l2: "960",
  },   
];

const Match_Odds = () => {
    const [show, setShow] = useState(false);
      const [selected, setSelected] = useState(null);
      const [showModal, setShowModal] = useState(false);
      const handleOpen = (team, odd, type) => {
        setSelected({
          team,
          odd,
          type, // <-- Back or Lay
        });
    
        setShow(true);
      };
      const openinfomodele = () => setShowModal(true);
      const closeModal = () => setShowModal(false);
  return (
    <>
      <div className="winner-container">
        <div className="header-row">
          <span className="header-title">
            Match Odds{" "}
            <button
              onClick={openinfomodele}
              style={{
                cursor: "pointer",
                marginLeft: "5px",
                background: "none",
                border: "none",
                fontSize: "16px",
                color: "white",
              }}
            >
              ⓘ
            </button>
          </span>
          <span className="matche">
            Matched <b>€ 10.6K</b>
          </span>
        </div>

        <div className="table-wrapper">
          <table className="bet-table">
            <thead>
              <tr>
                <th colSpan={3} className=""></th>
                <th colSpan={1} className="back-heading">
                  Back
                </th>

                <th colSpan={1} className="lay-heading">
                  Lay
                </th>
                <th colSpan={2} className="minmax-heading">
                  min/max 1- 0
                </th>
              </tr>
            </thead>

            <tbody>
              {data.map((row, i) => (
                <tr key={i}>
                  <td className="team">{row.team}</td>

                  <td
                    className={`back-cell1`}
                    onClick={() => handleOpen(row.team, row.b2)}
                  >
                    {row.b1}
                    <br />
                    <span className="right-cell">{row.c1}</span>
                  </td>
                  <td
                    className={`back-cell2`}
                    onClick={() => handleOpen(row.team, row.b2)}
                  >
                    {row.b2}
                    <br />
                    <span className="right-cell">{row.c2}</span>
                  </td>
                  <td
                    className={`back-cell`}
                    onClick={() => handleOpen(row.team, row.b3)}
                  >
                    {row.b3}
                    <br />
                    <span className="right-cell">{row.c3}</span>
                  </td>

                  <td
                    className={`lay-cell`}
                    onClick={() => handleOpen(row.team, row.l1, "lay")}
                  >
                    {row.l1 || "0"} <br />
                    <span className="right-cell">{row.l2 || "0"}</span>
                  </td>
                  <td className={`lay-cell1`}>
                    0 <br />
                    <span className="right-cell">0</span>
                  </td>
                  <td className="minmax">
                    0 <br />
                    <span className="right-cell">0</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Bet_model
        show={show}
        selected={selected}
        handleClose={() => setShow(false)}
      />
      <Book_mark />
      <Toss_Winner />
      <Fancy_bet />
      {/* Modal */}
      {showModal && (
        <>
          <div className="modal-overlay" onClick={closeModal}></div>

          <div className="modal-box">
            <h3>Information</h3>

            <div className="modal-content">
              {/* Yahan aapka 1000 words ya table aa sakta hai */}
              <p>
                Lorem ipsum dolor sit amet consectetur, adipisicing elit. 
                (yaha content scroll hoga)
              </p>

              {/* Example table */}
              <table border="1" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.from({ length: 50 }).map((_, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>Item {i + 1}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <button className="close-btn" onClick={closeModal}>
              ok
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default Match_Odds;
